export const queries = {
  allGiftCards: `
    query {
      allGiftCards(where: { isActive: true }) {
        id
        isActive
        heading
        subHeading
        items(where: { isActive: true }, orderBy: "priority") {
          id
          isActive
          name
          heading
          subHeading
          description
          imageEn {
            id
            isActive
            file {
              id
              filename
              publicUrl
            }
            name
          }
          imageFr {
            id
            isActive
            file {
              id
              filename
              publicUrl
            }
            name
          }
          button {
            id
            name
            url
          }
        }
      }
    }
`,
};
